import React, { useState } from "react";
import { toast } from "sonner";
import { MailPlus } from "lucide-react";
import api, { formatError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";

export function AddEmailInvite({ member, onDone }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.put(`/admin/members/${member.id}`, { email });
      toast.success(`${member.name} activated — set-password invite sent to ${email}`);
      setOpen(false); setEmail(""); onDone?.();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" className="bg-palm hover:bg-palm/90" data-testid={`member-add-email-${member.id}`}><MailPlus size={14} className="mr-1" /> Add email &amp; invite</Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Add email for {member.name}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">This turns the record into a login account and immediately sends the set-password link by email{member.phone ? " and SMS" : ""}.</p>
        <div><Label>Email address</Label><Input type="email" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@example.com" data-testid="add-email-input" /></div>
        <DialogFooter><Button className="bg-crimson" disabled={busy || !email.includes("@")} onClick={submit} data-testid="add-email-submit">Activate &amp; send invite</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
